/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module Sounds
 * @description
 */

var Model = require("../types/Model.js");
var window = require("global");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");
var Platform = ReactNative.Platform;
var AppState = ReactNative.AppState;

var LOOP_DELAY = 16;

module.exports = Model({
	name: "sounds",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_ringing: false,
	_shouldPlay: null,
	_receiving: false,
	_bannersEnabled: true,

	handle_trigger_play: handle_trigger_play,
	stop: handle_trigger_stop,
	play: play_sound
});

/**
 * Sets up listeners for triggers and initializes sound map
 */
function init() {
	this._shouldPlay = null;
	this.dispatch("ready");
}

function uninit() {
	this.stop();
}

function listeners() {
	return {
		"loadedsounds:updated": handle_load,
		"soundspreferences:updated": handle_updated_perferences,
		"focusstate:active": handle_trigger_play_first,
		"calling:statechange": handle_calling_update,
		"bannernotice:updated": handle_banner_notice_updated,
	};
}

function triggers() {
	return {
		"play": handle_trigger_play,
		"stop": handle_trigger_stop
	};
}

function handle_trigger_play_first(){
	if(this._receiving)
		this.handle_trigger_play({
			sound: "incoming",
			loop: true
		});
}


/**
 * Receives an object that contains the preferred sound for each state:
 * outgoing, incoming, busy, message, alert
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
function handle_updated_perferences(data) {
	this._preferences = data;

	return this.extend({
		preferences: data
	});
}

function handle_load(sounds) {
	this.extend({
		sounds: sounds
	});
}

/**
 * Handles triggers for playing sounds.  The trigger will containg a name (eg.'incoming')
 * and may contain volume (0-1) and may contain an intent (play/test).  If the
 * latter is not specified, '1' is assigned.
 * @param  {Object} data Must contain a `sound` name to play, may contain 'volume'
 */
function handle_trigger_play(data) {
	this.stop();
	if(Platform.OS === "ios" && AppState.currentState !== "active") return;

	var name = data.sound;
	if((name === "message" || name === "alert") && !this._bannersEnabled) return;
	var volume = data.volume;
	var loop = data.loop;
	if (!volume) volume = 1;

	var sounds_data = this.data;
	var preference = sounds_data.preferences[name];
	var sounds = sounds_data.sounds;

	var sound = sounds[preference];

	if (name === "incoming" && window.ring) {
		this.stop();
		this._ringing = true;
		var file = preference + ".mp3";
		window.ring.startRinging(file, noop, noop);
		return;
	}

	if(!sound) return;
	if(sound.isLoaded()) {
		this.play(sound, volume, loop);
	} else {
		var loadPromise = sounds.loading[preference];
		if(loadPromise) {
			this._shouldPlay = preference;
			loadPromise.then(after_load.bind(this, preference, data));
		}
	}
}

function after_load(preference, data) {
	if(this._shouldPlay === preference)
		handle_trigger_play.call(this, data);
}

/**
 * Handles triggers for stopping sounds. Stops all sounds registered.
 */
function handle_trigger_stop() {
	if (this._ringing && window.ring) {
		this._ringing = false;
		window.ring.stopRinging(noop, noop);
	}else if(this.playing) {
		stop_sound(this.playing);
	}

	this._shouldPlay = null;
	this.playing = null;
}

/**
 * Plays a sound from a given Audio element.  If the volume is undefined,
 * a volume value of 1 is specified.
 * @param  {Audio} sound_element A reference to an Audio element
 */
function play_sound(sound, volume, loop) {
	this.stop();
	this.playing = sound;

	var onFinish = loop ? replay.bind(this, sound, volume) : noop;

	sound
		.setVolume(volume)
		.play(onFinish);
}

function replay(sound, volume) {
	setTimeout(function(){
		if(this.playing !== sound) return;
		this.play(sound, volume, true);
	}.bind(this), LOOP_DELAY);
}

/**
 * Stops the playback from a given Audio element. Resets playback position.
 * @param  {Audio} sound_element A reference to an Audio element
 */
function stop_sound(sound) {
	sound.setVolume(0);
	sound.pause();
	sound.stop();
}

function noop() {}

function handle_calling_update(data) {
	if(data === "receiving")
		this._receiving = true;
	else this._receiving = false;
}

//to make banner notification sound disabled
function handle_banner_notice_updated(data){
	this._bannersEnabled = data;
}